import { createAction, emptyProps, props } from "@ngrx/store";

export const FETCH_CITY_MASTER_LIST = createAction(
    'FETCHCITYMASTERLIST',
    emptyProps
);

export const FETCH_CITY_MASTER_LIST_SUCCESS = createAction(
  'FETCH_CITY_MASTER_LIST_SUCCESS',
  props<{cities:any}>()
);



export const FETCH_CITY_MASTER = createAction(
    'FETCHCITYMASTER',
    props<{city:any}>()
);
